
const stickyClassName = 'sticky';

function setupSticky(element) {
    let timeout = null;
    window.addEventListener('scroll', (e) => {
        if(timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            checkSticky(element);
        }, 50);
    })
}

function checkSticky(element) {
    let y = window.scrollY;
    let isSticky = element.classList.contains(stickyClassName);

    if(y>0 && !isSticky) {
        element.classList.add(stickyClassName);
    } else if(y<=0 && isSticky) {
        element.classList.remove(stickyClassName);
    }
}

export default class Head {
    setup() {
        const rootElement = document.querySelector('#content .head');
        setupSticky(rootElement);
        checkSticky(rootElement);
    }
}
